/* ============================================================================
   RUFF90 — PROMO CODE MODAL
   ----------------------------------------------------------------------------
   The modal markup ("Have a Promo Code?") and its open/close handlers live in
   sections/Custom-Footer.liquid, which renders on every page.

   options-choice.js normally wires the submit button and the auto-open, but it
   is NOT loaded on templates/page.ruff90.json — none of that template's
   sections include it. So this file carries both:

     1. the submit flow (hands the code to Shopify via /discount/CODE)
     2. the auto-open when the visitor has no code in play

   No jQuery: this loads independently of the theme's script order.
   Loaded from layout/theme.liquid, gated on template.suffix == 'ruff90'.
   Also loaded by sections/ninety-top-onetime.liquid and
   sections/ninety-top-v2.liquid (templates ruff90-onetime and
   ruff90-onetime-v2) when their "Show promo code popup" setting is on.
   Those tags carry data-promo-only="true": the modal works the same, but the
   cart attribute writes below are skipped, so they stay ruff90 only.
   ========================================================================== */
(function () {
  'use strict';

  var OPEN_DELAY = 800;   // let the page paint before interrupting
  /* Read while this file executes (currentScript is null afterwards).
     Absent on templates/page.ruff90.json, so that page behaves as before. */
  var SELF = document.currentScript;
  var PROMO_ONLY = !!(SELF && SELF.getAttribute('data-promo-only') === 'true');
  var COOKIE_DAYS = 7;

  /* ---- Cart attributes recorded for internal reporting ----------------
     Fixed values written to the cart on every ruff90 visit. Rename or add
     freely; anything here lands on the order in Admin under "Additional
     details" and is readable in Liquid as cart.attributes['<name>'].
     Values are not shown to the customer unless a theme prints them.      */
  var CART_ATTRIBUTES = {
    'Welcome Box': 'true'
  };

  /* URL params captured onto the cart when present, so paid traffic can be
     attributed at order level. Add or remove keys as needed. */
  var CAPTURE_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getCookie(name) {
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(name + '=') === 0) {
        return decodeURIComponent(parts[i].slice(name.length + 1));
      }
    }
    return null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + d.toUTCString() + ';path=/';
  }

  /* Shopify only reports a discount once the cart holds something. A code
     claimed against an empty cart is kept for checkout and never appears
     here — so this is a secondary guard, and the cookie is the primary one. */
  function cartHasDiscount() {
    if (!window.fetch) return Promise.resolve(false);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return (cart.discount_codes || []).length > 0; })
      .catch(function () { return false; });
  }

  /* Writes cart attributes. Works on an empty cart — Shopify keeps them and
     carries them through to the order. Deduped per session so a visitor
     clicking around the page does not POST on every view. */
  function setCartAttributes(attrs) {
    var keys = Object.keys(attrs);
    if (!keys.length || !window.fetch) return;

    var signature = JSON.stringify(attrs);
    try {
      if (sessionStorage.getItem('ruff90_cart_attrs') === signature) return;
    } catch (e) { /* private mode — just write it */ }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      try { sessionStorage.setItem('ruff90_cart_attrs', signature); } catch (e) {}
    }).catch(function (err) {
      console.warn('[ruff90] cart attributes not saved:', err);
    });
  }

  function collectAttributes() {
    var attrs = {};
    Object.keys(CART_ATTRIBUTES).forEach(function (k) { attrs[k] = CART_ATTRIBUTES[k]; });

    var params = new URLSearchParams(window.location.search);
    CAPTURE_PARAMS.forEach(function (k) {
      var v = params.get(k);
      if (v) attrs[k] = v;
    });

    /* The promo code, once one is in play. Recorded for reporting only —
       the actual discount is applied by Shopify at /discount/CODE. */
    var code = getCookie('discount_code') || params.get('discount');
    if (code) attrs['Promo Code'] = code;

    return attrs;
  }

  ready(function () {
    if (!PROMO_ONLY) setCartAttributes(collectAttributes());

    var modal = document.getElementById('discount');
    var openBtn = document.getElementById('discountBtn');
    if (!modal || !openBtn) return;              // footer modal not on the page
    if (window.__ruff90DiscountBound) return;    // never double-bind
    window.__ruff90DiscountBound = true;

    /* ---- Submit: hand the code to Shopify, then return to this page ---- */
    var submit = document.getElementById('promo_code_submit');
    var input = document.getElementById('promo_code_modal');

    if (submit && input) {
      submit.addEventListener('click', function (e) {
        e.preventDefault();
        var code = (input.value || '').trim();
        if (!code) return;

        setCookie('discount_code', code, COOKIE_DAYS);
        modal.style.display = 'none';

        /* This is how the code reaches the cart: Shopify applies it to the
           session at /discount/CODE and redirects back. Nothing is attached
           to the line item by hand. */
        var back = window.location.pathname + window.location.search;
        window.location.href = '/discount/' + encodeURIComponent(code) +
          '?redirect=' + encodeURIComponent(back);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit.click(); }
      });
    }

    /* ---- "Need A Code" reveals the hint ---- */
    var needCode = document.getElementById('need-code');
    var drop = document.getElementById('discount_drop');
    if (needCode && drop) {
      needCode.addEventListener('click', function (e) {
        e.preventDefault();
        drop.style.display = 'block';
      });
    }

    /* ---- Auto-open when there is no code in play ----
       Deliberately synchronous. This used to wait on fetch('/cart.js'), but if
       that request is blocked by an extension and hangs rather than rejecting,
       the promise never settles and the modal never opens. The cart check was
       a weak guard anyway: a code claimed against an empty cart is held for
       checkout and never appears in cart.discount_codes. The cookie is the
       reliable signal, so it does the gating on its own. */
    if (getCookie('discount_code')) return;                     // already entered one
    if (/[?&]discount=/i.test(window.location.search)) return;  // arriving with one

    setTimeout(function () { openBtn.click(); }, OPEN_DELAY);

    /* Backstop: if the cart does turn out to carry a code, close it again.
       Runs independently, so a blocked or hanging request costs nothing. */
    cartHasDiscount().then(function (has) {
      if (has) modal.style.display = 'none';
    });
  });
})();


